module.exports = __webpack_public_path__ + "img/newsletter.9b89b476.jpg";